"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AbsenteeismOfSweeper = function AbsenteeismOfSweeper(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 24 24", className: "custom-icon" }, props),
    _react2.default.createElement("path", { d: "M22.782 17.234c.262.2.292.55.066.782l-3.513 3.614a.685.685 0 0 1-.884.059l-2.74-2.083a.613.613 0 0 1-.052-.044c-.615-.513-.98-1.206-1.032-1.956a2.66 2.66 0 0 1 .49-1.719l-2.646-2.01c.018 3.011.056 6.445.133 8.092.064 1.378-2.352 1.372-2.415 0-.114-2.43-.142-4.859-.149-7.289-.114.007-.229.007-.343.002-.007 2.43-.035 4.859-.148 7.287-.064 1.372-2.48 1.377-2.416 0 .116-2.493.169-8.955.185-12.008L6.28 9.173c-.403.261-.817.505-1.238.71-1.495.729-2.914-1.985-3.201-2.887-.208-.65-.25-1.065-.192-1.343l-.584-.443a.153.153 0 0 1-.02-.235l.432-.444a.206.206 0 0 1 .265-.017l.66.5c.444-.071.976.17 1.149.544.068.149.132.31.193.477l1.648 1.252c.96-.627 1.345-.9 2.162-1.48 1.026-.728 2.798-.795 4.196-.31 2.9 1.009 1.978 4.437 1.307 7.104a1.14 1.14 0 0 1-.173.38l2.909 2.21c.518-.39 1.16-.63 1.849-.686a3.615 3.615 0 0 1 2.399.647l2.74 2.082zM10.263 4.474c-1.279 0-2.316-.778-2.316-1.737C7.947 1.777 8.984 1 10.263 1c1.28 0 2.316.778 2.316 1.737 0 .959-1.037 1.737-2.316 1.737z" })
  );
};

exports.default = AbsenteeismOfSweeper;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/absenteeism of-sweeper.js
// module id = ../lib/egov-ui-kit/custom-icons/absenteeism of-sweeper.js
// module chunks = 504